<div class="chip-set-container">
  <!-- Combined Warning Chips (when both recipient and donor have the same warning) -->
  <mat-chip-set class="custom-chip-color">
    <!-- Combined Awaiting ENIS sync -->
    <mat-chip *ngIf="bothAwaitingEnisSync()" color="warn" [matTooltip]="getCombinedEnisSyncTooltip()" matTooltipClass="multiline-tooltip">Awaiting ENIS sync</mat-chip>
    <!-- Combined Assign Center -->
    <mat-chip *ngIf="bothHaveUnknownCenter()" color="warn" [matTooltip]="getCombinedUnknownCenterTooltip()" matTooltipClass="multiline-tooltip">Assign Center</mat-chip>
    <!-- Combined Missing Date of Birth -->
    <mat-chip *ngIf="bothHaveMissingDob()" color="warn" [matTooltip]="getCombinedMissingDobTooltip()" matTooltipClass="multiline-tooltip">Missing Date of Birth</mat-chip>
    <!-- Combined Missing Blood Type -->
    <mat-chip *ngIf="!bothAwaitingEnisSync() && bothHaveMissingBloodType()" color="warn" [matTooltip]="getCombinedMissingBloodTypeTooltip()" matTooltipClass="multiline-tooltip">Missing Blood Type</mat-chip>
    <!-- Combined Missing HLA -->
    <mat-chip *ngIf="!bothAwaitingEnisSync() && bothHaveMissingHla()" color="warn" [matTooltip]="getCombinedMissingHlaTooltip()" matTooltipClass="multiline-tooltip">Missing HLA</mat-chip>
  </mat-chip-set>

  <!-- Recipient Warning Chips (only when recipient has them) -->
  <mat-chip-set *ngIf="recipient as recipient" class="custom-chip-color">
    <mat-chip *ngIf="onlyRecipientAwaitingEnisSync()" color="warn">Awaiting ENIS sync</mat-chip>
    <mat-chip *ngIf="onlyRecipientHasUnknownCenter() && !onlyRecipientAwaitingEnisSync()" color="warn">Assign Center</mat-chip>
    <mat-chip *ngIf="onlyRecipientHasMissingDob() && !onlyRecipientAwaitingEnisSync()" color="warn">Missing Date of Birth</mat-chip>
    <mat-chip *ngIf="!onlyRecipientAwaitingEnisSync() && onlyRecipientHasMissingBloodType()" color="warn">Missing Blood Type</mat-chip>
    <mat-chip *ngIf="!onlyRecipientAwaitingEnisSync() && onlyRecipientHasMissingHla()" color="warn">Missing HLA</mat-chip>
    <mat-chip *ngIf="!isRecipientAwaitingEnisSync() && recipient?.virtualPRA == null && recipient?.unacceptables" color="warn">Missing vPRA</mat-chip>
    <mat-chip *ngIf="!isRecipientAwaitingEnisSync() && hasOutdatedScreening()" color="warn">Outdated Screening</mat-chip>
    <mat-chip
      *ngIf="shouldShowMultipleDonorWarning()"
      color="warn"
      [class.clickable-chip]="canDismissMultipleDonorWarning"
      (click)="canDismissMultipleDonorWarning ? onMultipleDonorWarningClick($event) : null"
      [matTooltip]="getMultipleDonorsWarningTooltipText()">
      Check: Multiple donors
    </mat-chip>
    <mat-chip
      *ngIf="shouldShowAcceptableBloodTypesWarning()"
      color="warn"
      [class.clickable-chip]="canDismissAcceptableBloodTypesWarning"
      (click)="canDismissAcceptableBloodTypesWarning ? onAcceptableBloodTypesWarningClick($event) : null"
      [matTooltip]="getAcceptableBloodTypesWarningTooltipText()">
      Check acceptables
    </mat-chip>
    <mat-chip
      *ngIf="shouldShowMaxDonorAgeWarning()"
      color="warn"
      [class.clickable-chip]="canDismissMaxDonorAgeWarning"
      (click)="canDismissMaxDonorAgeWarning ? onMaxDonorAgeWarningClick($event) : null"
      [matTooltip]="getMaxDonorAgeWarningTooltipText()">
      Check max donor age
    </mat-chip>
    <mat-chip
      *ngIf="shouldShowMaxMismatchesWarning()"
      color="warn"
      [class.clickable-chip]="canDismissMaxMismatchesWarning"
      (click)="canDismissMaxMismatchesWarning ? onMaxMismatchesWarningClick($event) : null"
      [matTooltip]="getMaxMismatchesWarningTooltipText()">
      Check max mismatches
    </mat-chip>
  </mat-chip-set>

  <!-- Donor Warning Chips (only when donor has them) -->
  <mat-chip-set *ngIf="donor as donor" class="custom-chip-color-donor">
    <mat-chip *ngIf="onlyDonorAwaitingEnisSync()" color="warn">Awaiting ENIS sync</mat-chip>
    <mat-chip *ngIf="onlyDonorHasUnknownCenter() && !onlyDonorAwaitingEnisSync()" color="warn">Assign Center</mat-chip>
    <mat-chip *ngIf="onlyDonorHasMissingDob() && !onlyDonorAwaitingEnisSync()" color="warn">Missing Date of Birth</mat-chip>
    <mat-chip *ngIf="!onlyDonorAwaitingEnisSync() && onlyDonorHasMissingBloodType()" color="warn">Missing Blood Type</mat-chip>
    <mat-chip *ngIf="!onlyDonorAwaitingEnisSync() && onlyDonorHasMissingHla()" color="warn">Missing HLA</mat-chip>
  </mat-chip-set>

  <!-- Combined Priority/Privileges Chips -->
  <mat-chip-set class="custom-priority-chip-color">
    <!-- Combined Privileges -->
    <mat-chip
      class="custom-priority-chip-color"
      *ngIf="bothHavePrivileges()"
      color="warn"
      [matTooltip]="getCombinedPrivilegesTooltip()"
      matTooltipClass="multiline-tooltip">
      Privileges
    </mat-chip>
  </mat-chip-set>

  <!-- Recipient Priority Chips (only when recipient has them) -->
  <mat-chip-set *ngIf="recipient as recipient" class="custom-priority-chip-color">
    <mat-chip
      class="custom-priority-chip-color"
      *ngIf="recipient.priority"
      color="warn"
      [matTooltip]="getPriorityTooltipText()">
      Priority
    </mat-chip>
    <mat-chip
      class="custom-priority-chip-color"
      *ngIf="onlyRecipientHasPrivileges()"
      color="warn"
      [matTooltip]="getRecipientPrivilegesText()"
      matTooltipClass="multiline-tooltip">
      Privileges
    </mat-chip>
  </mat-chip-set>

  <!-- Donor Priority Chips (only when donor has them) -->
  <mat-chip-set *ngIf="donor as donor" class="custom-priority-chip-color-donor">
    <mat-chip
      class="custom-priority-chip-color-donor"
      *ngIf="onlyDonorHasPrivileges()"
      color="warn"
      [matTooltip]="getDonorPrivilegesText()">
      Privileges
    </mat-chip>
  </mat-chip-set>

  <!-- Combined Locked Chips -->
  <mat-chip-set class="custom-locked-chip-color">
    <mat-chip class="custom-locked-chip-color" *ngIf="bothAreLocked()" [matTooltip]="getCombinedLockedTooltip()" matTooltipClass="multiline-tooltip">Locked</mat-chip>
  </mat-chip-set>

  <!-- Recipient Locked Chip (only when recipient is locked) -->
  <mat-chip-set *ngIf="recipient as recipient" class="custom-locked-chip-color">
    <mat-chip class="custom-locked-chip-color" *ngIf="onlyRecipientIsLocked()">Locked</mat-chip>
  </mat-chip-set>

  <!-- Donor Locked Chip (only when donor is locked) -->
  <mat-chip-set *ngIf="donor as donor" class="custom-locked-chip-color-donor">
    <mat-chip class="custom-locked-chip-color-donor" *ngIf="onlyDonorIsLocked()">Locked</mat-chip>
  </mat-chip-set>

  <!-- Combined Selected Chips -->
  <mat-chip-set class="custom-selected-chip-color">
    <mat-chip class="custom-selected-chip-color" *ngIf="bothAreSelected()" [matTooltip]="getCombinedSelectedTooltip()" matTooltipClass="multiline-tooltip">Selected</mat-chip>
  </mat-chip-set>

  <!-- Recipient Selected Chip (only when recipient is selected) -->
  <mat-chip-set *ngIf="recipient as recipient" class="custom-selected-chip-color">
    <mat-chip class="custom-selected-chip-color" *ngIf="onlyRecipientIsSelected()">Selected</mat-chip>
  </mat-chip-set>

  <!-- Donor Selected Chip (only when donor is selected) -->
  <mat-chip-set *ngIf="donor as donor" class="custom-selected-chip-color-donor">
    <mat-chip class="custom-selected-chip-color-donor" *ngIf="onlyDonorIsSelected()">Selected</mat-chip>
  </mat-chip-set>

  <!-- Combined Transplanted Chips -->
  <mat-chip-set class="custom-transplanted-chip-color">
    <mat-chip class="custom-transplanted-chip-color" *ngIf="bothAreTransplanted()" [matTooltip]="getCombinedTransplantedTooltip()" matTooltipClass="multiline-tooltip">Transplanted</mat-chip>
  </mat-chip-set>

  <!-- Recipient Transplanted Chip (only when recipient is transplanted) -->
  <mat-chip-set *ngIf="recipient as recipient" class="custom-transplanted-chip-color">
    <mat-chip class="custom-transplanted-chip-color" *ngIf="onlyRecipientIsTransplanted()">Transplanted</mat-chip>
  </mat-chip-set>

  <!-- Donor Transplanted Chip (only when donor is transplanted) -->
  <mat-chip-set *ngIf="donor as donor" class="custom-transplanted-chip-color-donor">
    <mat-chip class="custom-transplanted-chip-color-donor" *ngIf="onlyDonorIsTransplanted()">Transplanted</mat-chip>
  </mat-chip-set>
</div>